import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';

import { getApplicationStatusOptionItems } from 'common/householdApplication/applicationHelpers';

const SrApplicationStatusTableCell = ({ application, listing, onChange, disabled }) => {
  const optionItems = getApplicationStatusOptionItems({ listing });

  return (
    <td className="SrApplicationStatusTableCell">
      <select
        className={classnames({ disabled })}
        value={application.status}
        onChange={(e) => {
          const applicationStatus = e.target.value;
          onChange({
            applicationStatus: applicationStatus,
            applicationId: application.id,
            listingId: listing.id,
            householdId: application.householdId,
          });
        }}
      >
        {optionItems.map((householdApplicationStatus) => (
          <option key={householdApplicationStatus.value} value={householdApplicationStatus.value}>
            {householdApplicationStatus.label}
          </option>
        ))}
      </select>
      {application.lastStatusUpdateDate && (
        <span className="tooltip">
          {momentWithAustinTimezone(application.lastStatusUpdateDate).format(
            'h:mmA [on] MMM D, YYYY',
          )}
        </span>
      )}
    </td>
  );
};

SrApplicationStatusTableCell.propTypes = {
  application: PropTypes.object.isRequired,
  listing: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

SrApplicationStatusTableCell.displayName = 'SrApplicationStatusTableCell';

export default SrApplicationStatusTableCell;
